import React from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import MoreByAuthor from '../../_partials/MoreByAuthor';
import TextualThumbBlock from '../../_partials/TextualThumbBlock';
export var MoreJournals = function (_a) {
    var moreJournals = _a.moreJournals, parentDeviation = _a.parentDeviation, isLoading = _a.isLoading;
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'moreJournals' } },
        React.createElement(TextualThumbBlock, { streamKey: "moreJournals", deviations: moreJournals, parentDeviation: parentDeviation, titleOverride: parentDeviation.author && (React.createElement(MoreByAuthor, { author: parentDeviation.author, i18nSubKey: "moreJournals" })), maxLength: 4, isLoading: isLoading })));
};
MoreJournals.displayName = 'MoreJournals';
export default MoreJournals;
//# sourceMappingURL=MoreJournals.js.map